/* Aurel theme — vanilla JS, no dependencies. Loaded with `defer`. */
(function () {
  'use strict';

  var T = window.AurelTheme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};
  var money = T.moneyFormat || '${{amount}}';

  /* ---------------- utilities ---------------- */

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return money.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function toast(message, type) {
    var stack = $('#toast-stack');
    if (!stack) return;
    var el = document.createElement('div');
    el.className = 'toast' + (type === 'error' ? ' toast--error' : '');
    el.setAttribute('role', 'status');
    el.textContent = message;
    stack.appendChild(el);
    setTimeout(function () {
      el.style.opacity = '0';
      setTimeout(function () { el.remove(); }, 250);
    }, 3600);
  }

  /* ---------------- focus trap + overlays ---------------- */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var openLayers = [];

  function lockScroll(lock) {
    document.body.classList.toggle('is-locked', lock);
  }

  function openLayer(el, trigger) {
    if (!el) return;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    el.dataset.trigger = trigger && trigger.id ? trigger.id : '';
    el._trigger = trigger || document.activeElement;
    openLayers.push(el);
    lockScroll(true);
    var target = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
    if (target) setTimeout(function () { target.focus(); }, 60);
  }

  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openLayers = openLayers.filter(function (l) { return l !== el; });
    if (!openLayers.length) lockScroll(false);
    if (el._trigger && document.contains(el._trigger)) el._trigger.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-open-layer]');
    if (opener) {
      event.preventDefault();
      openLayer(document.getElementById(opener.getAttribute('data-open-layer')), opener);
      return;
    }
    var closer = event.target.closest('[data-close-layer]');
    if (closer) {
      event.preventDefault();
      closeLayer(closer.closest('.drawer, .modal'));
      return;
    }
    if (event.target.classList && event.target.classList.contains('drawer__overlay')) {
      closeLayer(event.target.closest('.drawer'));
    }
    if (event.target.classList && event.target.classList.contains('modal__overlay')) {
      closeLayer(event.target.closest('.modal'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openLayers.length) return;
    var layer = openLayers[openLayers.length - 1];
    if (event.key === 'Escape') { closeLayer(layer); return; }
    if (event.key !== 'Tab') return;
    var items = $$(FOCUSABLE, layer).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* ---------------- header ---------------- */

  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Desktop dropdowns / mega menus
    $$('[data-nav-item]', header).forEach(function (item) {
      var button = $('[data-nav-toggle]', item);
      if (!button) return;
      var close = function () {
        item.dataset.open = 'false';
        button.setAttribute('aria-expanded', 'false');
      };
      var open = function () {
        $$('[data-nav-item]', header).forEach(function (other) {
          if (other !== item) {
            other.dataset.open = 'false';
            var b = $('[data-nav-toggle]', other);
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });
        item.dataset.open = 'true';
        button.setAttribute('aria-expanded', 'true');
      };
      button.addEventListener('click', function (e) {
        e.preventDefault();
        item.dataset.open === 'true' ? close() : open();
      });
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
    });

    // Mobile nav accordions
    $$('[data-mobile-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var parent = button.closest('.mobile-nav__item');
        var open = parent.dataset.open === 'true';
        parent.dataset.open = open ? 'false' : 'true';
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------------- color mode ---------------- */

  function initColorMode() {
    var root = document.documentElement;
    var toggles = $$('[data-color-mode-toggle]');
    if (!toggles.length) return;
    toggles.forEach(function (button) {
      button.addEventListener('click', function () {
        var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        root.setAttribute('data-theme', next);
        try { localStorage.setItem('aurel:color-mode', next); } catch (e) {}
        toggles.forEach(function (b) { b.setAttribute('aria-pressed', String(next === 'dark')); });
      });
    });
  }

  /* ---------------- cart ---------------- */

  function refreshCartUI() {
    return fetch(routes.cart_url + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var current = $('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (node) {
          if (!count) return;
          node.textContent = count.textContent;
          node.hidden = count.hidden;
        });
      })
      .catch(function () {});
  }

  function addToCart(form, button) {
    var body = new FormData(form);
    body.append('sections_url', window.location.pathname);
    if (button) {
      button.dataset.label = button.textContent;
      button.textContent = strings.adding || 'Adding';
      button.setAttribute('aria-disabled', 'true');
    }
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          toast(result.data.description || result.data.message || strings.error || 'Error', 'error');
          return;
        }
        toast(strings.added || 'تمت الإضافة إلى السلة');
        return refreshCartUI().then(function () {
          var drawer = $('#cart-drawer');
          if (drawer && T.cartType === 'drawer') openLayer(drawer, button);
        });
      })
      .catch(function () { toast(strings.error || 'حدث خطأ، حاول مرة أخرى', 'error'); })
      .finally(function () {
        if (button && button.dataset.label) {
          button.textContent = button.dataset.label;
          button.removeAttribute('aria-disabled');
        }
      });
  }

  function changeCartLine(line, quantity) {
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCartUI();
      });
  }

  function initCart() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      addToCart(form, form.querySelector('[data-add-button]'));
    });

    document.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        changeCartLine(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
        return;
      }
      var step = event.target.closest('[data-qty-step]');
      if (step) {
        var wrap = step.closest('.qty');
        var input = wrap.querySelector('input');
        var value = parseInt(input.value, 10) || 1;
        value = step.getAttribute('data-qty-step') === 'up' ? value + 1 : Math.max(parseInt(input.min || 1, 10), value - 1);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      changeCartLine(parseInt(input.getAttribute('data-cart-quantity'), 10), parseInt(input.value, 10));
    });
  }

  /* ---------------- predictive search ---------------- */

  function initSearch() {
    $$('[data-predictive-search]').forEach(function (wrapper) {
      var input = $('input[type="search"]', wrapper);
      var results = $('[data-predictive-results]', wrapper);
      if (!input || !results || !routes.predictive_search_url) return;

      var run = debounce(function () {
        var term = input.value.trim();
        if (term.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
        results.hidden = false;
        results.innerHTML = '<div class="predictive__list"><div class="skeleton" style="height:64px"></div><div class="skeleton" style="height:64px"></div></div>';
        var url = routes.predictive_search_url + '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,article,page&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = fresh ? fresh.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 260);

      input.addEventListener('input', run);
      input.addEventListener('focus', run);
    });

    $$('[data-search-suggestion]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = button.closest('.search-drawer, form') || document;
        var input = form.querySelector('input[type="search"]');
        if (!input) return;
        input.value = button.textContent.trim();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    });
  }

  /* ---------------- facets ---------------- */

  function initFacets() {
    var forms = $$('[data-facet-form]');
    if (!forms.length) return;
    forms.forEach(function (form) {
      form.addEventListener('change', function () {
        if (form.dataset.autoSubmit === 'false') return;
        form.submit();
      });
    });
  }

  /* ---------------- product gallery + sticky buy ---------------- */

  function initProduct() {
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main]', gallery);
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          var img = main.querySelector('img');
          if (img && src) { img.src = src; img.srcset = ''; img.alt = alt; }
          $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });

    var sticky = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -30% 0px' }).observe(anchor);
    }

    $$('[data-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (!form) return;
        var input = form.querySelector('[name="id"]');
        if (input) input.value = select.value;
      });
    });
  }

  /* ---------------- wishlist + recently viewed ---------------- */

  function readStore(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }
  function writeStore(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value.slice(0, 40))); } catch (e) {}
  }

  function initWishlist() {
    var list = readStore('aurel:wishlist');
    $$('[data-wishlist]').forEach(function (button) {
      var handle = button.getAttribute('data-wishlist');
      button.setAttribute('aria-pressed', String(list.indexOf(handle) > -1));
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var current = readStore('aurel:wishlist');
        var index = current.indexOf(handle);
        if (index > -1) { current.splice(index, 1); button.setAttribute('aria-pressed', 'false'); }
        else { current.unshift(handle); button.setAttribute('aria-pressed', 'true'); }
        writeStore('aurel:wishlist', current);
      });
    });
  }

  function initRecentlyViewed() {
    var handle = document.body.getAttribute('data-product-handle');
    if (handle) {
      var seen = readStore('aurel:recent').filter(function (h) { return h !== handle; });
      seen.unshift(handle);
      writeStore('aurel:recent', seen);
    }
    var container = $('[data-recently-viewed]');
    if (!container) return;
    var handles = readStore('aurel:recent').filter(function (h) { return h !== handle; }).slice(0, 8);
    if (!handles.length) { container.closest('[data-recently-viewed-section]').hidden = true; return; }
    var query = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
    fetch(routes.search_url + '?type=product&options[unavailable_products]=last&q=' + encodeURIComponent(query) + '&section_id=recently-viewed-results')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recently-viewed-inner]');
        if (fresh && fresh.children.length) container.innerHTML = fresh.innerHTML;
        else container.closest('[data-recently-viewed-section]').hidden = true;
      })
      .catch(function () { container.closest('[data-recently-viewed-section]').hidden = true; });
  }

  /* ---------------- quick view ---------------- */

  function initQuickView() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-quick-view]');
      if (!button) return;
      event.preventDefault();
      var modal = $('#quick-view');
      var body = $('[data-quick-view-body]', modal);
      if (!modal || !body) return;
      body.innerHTML = '<div class="skeleton" style="height:320px"></div>';
      openLayer(modal, button);
      fetch(button.getAttribute('data-quick-view') + '?section_id=quick-view')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-quick-view-inner]');
          body.innerHTML = fresh ? fresh.innerHTML : '';
        })
        .catch(function () { closeLayer(modal); });
    });
  }

  /* ---------------- carousels ---------------- */

  function initCarousels() {
    $$('[data-carousel]').forEach(function (carousel) {
      var track = $('[data-carousel-track]', carousel);
      if (!track) return;
      $$('[data-carousel-nav]', carousel).forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = button.getAttribute('data-carousel-nav') === 'next' ? 1 : -1;
          if (document.documentElement.dir === 'rtl') direction = -direction;
          track.scrollBy({ left: direction * Math.max(260, track.clientWidth * 0.75), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------------- countdown ---------------- */

  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) return;
      var nodes = {
        days: $('[data-unit="days"]', el),
        hours: $('[data-unit="hours"]', el),
        minutes: $('[data-unit="minutes"]', el),
        seconds: $('[data-unit="seconds"]', el)
      };
      var tick = function () {
        var diff = Math.max(0, target - Date.now());
        var s = Math.floor(diff / 1000);
        var values = {
          days: Math.floor(s / 86400),
          hours: Math.floor((s % 86400) / 3600),
          minutes: Math.floor((s % 3600) / 60),
          seconds: s % 60
        };
        Object.keys(nodes).forEach(function (key) {
          if (nodes[key]) nodes[key].textContent = String(values[key]).padStart(2, '0');
        });
        if (diff <= 0) clearInterval(timer);
      };
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------------- back to top ---------------- */

  function initBackToTop() {
    var button = $('[data-back-to-top]');
    if (!button) return;
    var onScroll = function () { button.classList.toggle('is-visible', window.scrollY > 700); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------------- copy link ---------------- */

  function initShare() {
    $$('[data-copy-link]').forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-copy-link') || window.location.href;
        if (navigator.share) { navigator.share({ url: url }).catch(function () {}); return; }
        navigator.clipboard.writeText(url).then(function () { toast(strings.copied || 'تم نسخ الرابط'); });
      });
    });
  }

  /* ---------------- boot ---------------- */

  function boot() {
    initHeader();
    initColorMode();
    initCart();
    initSearch();
    initFacets();
    initProduct();
    initWishlist();
    initRecentlyViewed();
    initQuickView();
    initCarousels();
    initCountdown();
    initBackToTop();
    initShare();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);

  window.AurelTheme = Object.assign(T, {
    toast: toast,
    formatMoney: formatMoney,
    openLayer: openLayer,
    closeLayer: closeLayer,
    refreshCartUI: refreshCartUI
  });
})();
